import type { ReactNode } from 'react';
import { PageContainer } from '@/components/ds';
import { usePlanFeatures } from '@/hooks/usePlanFeatures';
import type { PlanFeatureKey } from '@/api/billing.api';
import { PlanFeatureLocked } from './PlanFeatureLocked';

/**
 * A page the plan may not include. Renders the page when it does, and the
 * upgrade panel in its place when it does not, so a link from anywhere (a
 * bookmark, a notification, the sidebar) lands somewhere useful.
 */
export function PlanFeatureGate({
  feature,
  children,
}: {
  feature: PlanFeatureKey;
  children: ReactNode;
}) {
  const { has } = usePlanFeatures();
  if (has(feature)) return <>{children}</>;
  return (
    <PageContainer>
      <PlanFeatureLocked feature={feature} />
    </PageContainer>
  );
}
